export const sendGTM = (event) => {
  if (window.dataLayer) {
    window.dataLayer.push({ event });
  } else if (process.env.TARGET === 'dev') {
    console.log('%cGTM log:', 'background: #6c5f42; color: #fff', event);
  }
};

export const GTM_EVENTS = {
  MOZIO_FORM_SHOW: 'mozio_form_show',
  MOZIO_ROUTES_SHOW: 'mozio_routes_show',
};
